import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { EditEcowasBusinessConfigTableComponent } from '../Table/edit-ecowas-business-config-table/edit-ecowas-business-config-table.component';

@Component({
  selector: 'app-view-ecowas-business-config-table',
  templateUrl: './view-ecowas-business-config-table.component.html',
  styleUrls: ['./view-ecowas-business-config-table.component.scss']
})
export class ViewEcowasBusinessConfigTableComponent implements OnInit {

  getBusinessdata:string;
  businessData = this.data.businessData
  constructor(public dialogRef: MatDialogRef<ViewEcowasBusinessConfigTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog) { }

  ngOnInit(): void {
    // this.getBusinessdata = .businessData
    this.getBusinessdata =this.data.businessData
    console.log("auuaa",this.getBusinessdata)
  }
  onClose(){
    this.dialogRef.close()
  }
  businessUpdateClick(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(EditEcowasBusinessConfigTableComponent, {
      width:'900px',
      data: { rowData: row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
  }
}
